import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import { defineIntegration } from '@sentry/core';
import { copyFlagsFromScopeToEvent, insertFlagToScope } from '../../../utils/featureFlags.js';
var openFeatureIntegration = defineIntegration(function () {
  return {
    name: 'OpenFeature',
    processEvent: function processEvent(event, _hint, _client) {
      return copyFlagsFromScopeToEvent(event);
    }
  };
});

/**
 * OpenFeature Hook class implementation.
 */
var OpenFeatureIntegrationHook = /*#__PURE__*/function () {
  function OpenFeatureIntegrationHook() {
    _classCallCheck(this, OpenFeatureIntegrationHook);
  }
  _createClass(OpenFeatureIntegrationHook, [{
    key: "after",
    value:
    /**
     * Successful evaluation result.
     */
    function after(_hookContext, evaluationDetails) {
      insertFlagToScope(evaluationDetails.flagKey, evaluationDetails.value);
    }

    /**
     * On error evaluation result.
     */
  }, {
    key: "error",
    value: function error(hookContext, _error, _hookHints) {
      insertFlagToScope(hookContext.flagKey, hookContext.defaultValue);
    }
  }]);
  return OpenFeatureIntegrationHook;
}();
export { OpenFeatureIntegrationHook, openFeatureIntegration };